import { Extension } from "@37signals/lexxy"
import {
  $getSelection,
  $isRangeSelection,
  COMMAND_PRIORITY_EDITOR,
  defineExtension
} from "lexical"

const INSERT_TOKEN_COMMAND = "insertToken"

export class TokenExtension extends Extension {
  get enabled() {
    return !!this.listTemplateId
  }

  get listTemplate() {
    return document.getElementById(this.listTemplateId)
  }

  get listTemplateId() {
    return this.editorElement.dataset.tokenTemplate
  }

  /**
   * Registering a command in Lexical connects the click to an action.
   * The button needs data-command="insertToken" and data-payload for the
   * token that will be inserted.
   */
  get lexicalExtension() {
    return defineExtension({
      name: "mstone/token",
      register: (editor) => {
        return editor.registerCommand(
          INSERT_TOKEN_COMMAND,
          (payload) => {
            if (!payload) return false

            const selection = $getSelection()
            if (!$isRangeSelection(selection)) return false

            selection.insertText(payload)
            return true
          },
          COMMAND_PRIORITY_EDITOR
        )
      }
    })
  }

  initializeToolbar(toolbar) {
    const dropdown = this.#buildDropdown()
    const alignDropdown = toolbar.querySelector("[data-mstn-name=alignment]")

    if (alignDropdown) {
      alignDropdown.insertAdjacentElement("afterend", dropdown)
    } else {
      toolbar.appendChild(dropdown)
    }
  }

  #buildDropdown() {
    const dropdown = this.#buildDropdownElement()
    const trigger = this.#buildTrigger()
    const panel = this.#buildPanel()

    dropdown.dataset["position"] = 3
    trigger.appendChild(this.#buildIcon())
    dropdown.appendChild(trigger)

    if (this.listTemplate) {
      const tokenList = this.listTemplate.content.cloneNode(true)
      panel.appendChild(tokenList)
    }

    dropdown.appendChild(panel)

    return dropdown
  }

  #buildDropdownElement() {
    let dropdown = document.createElement("lexxy-toolbar-dropdown")
    dropdown.className = [
      "lexxy-editor__toolbar-dropdown",
      "lexxy-editor__toolbar-dropdown--chevron",
      "mstn-token-dropdown"
    ].join(' ')

    return dropdown
  }

  #buildPanel() {
    let panel = document.createElement("div")

    panel.setAttribute("data-dropdown-panel", "")
    panel.setAttribute("role", "menu")
    panel.hidden = true
    panel.className = [
      "lexxy-editor__toolbar-dropdown-list",
      "mstn-token-list",
      "block"
    ].join(' ')

    return panel
  }

  #buildTrigger() {
    let trigger = document.createElement("button")
    trigger.type = "button"
    trigger.className = "lexxy-editor__toolbar-button lexxy-editor__toolbar-button--chevron"
    trigger.setAttribute("data-dropdown-trigger", "")
    trigger.setAttribute("name", "insert-token")
    trigger.setAttribute("title", "Insert Token")
    trigger.setAttribute("aria-haspopup", "menu")
    trigger.setAttribute("aria-expanded", "false")

    return trigger
  }

  #buildIcon() {
    let icon = document.createElement("i")
    icon.className = "fa-solid fa-brackets-curly"

    return icon
  }
}
